import type { FC } from 'react'
import { Button } from '@mui/material'
import FacebookIcon from '@mui/icons-material/Facebook'
import { FBRequiredScoeps } from '~/api/FacebookRepository'

type Props = {
  onFacebookLoggedIn: (res: fb.StatusResponse) => void
  reauthorize?: boolean
}

export const FacebookLoginButton: FC<Props> = ({ onFacebookLoggedIn, reauthorize }) => {
  const handleLogin = () => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!window.FB) {
      alert(
        'Facebook SDKが読み込めなかったため、Facebook連携が行えません。広告ブロッカーやトラッキング防止機能を使用している場合は、設定からこのサイト https://marketing.toridori.me/ を除外してください。',
      )
      return
    }
    FB.login(onFacebookLoggedIn, {
      scope: FBRequiredScoeps.join(','),
      auth_type: reauthorize ? 'reauthorize' : undefined,
      return_scopes: true,
    })
  }

  return (
    <Button startIcon={<FacebookIcon />} variant="contained" sx={{ fontWeight: 'bold' }} onClick={handleLogin}>
      Facebookログイン
    </Button>
  )
}
